import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import OfferFormStep from './OfferFormStep';

const OfferDisplay = () => {
  const { offerId } = useParams();
  const location = useLocation();

  const getTokenFromQuery = () => {
    const params = new URLSearchParams(location.search);
    return params.get('token');
  };

  const token = getTokenFromQuery();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <OfferFormStep
          offerId={offerId}
          token={token}
          onSuccess={() => {}}
          onReject={() => window.close()}
          showCloseButton={true}
          onClose={() => window.close()}
          showOnlyItems={true}
        />
      </div>
    </div>
  );
};

export default OfferDisplay;
